import { createTheme } from "@mui/material";
declare module '@mui/material/styles' {
    interface BreakpointOverrides {
      xs: true;
      sm: true;
      md: true;
      lg: true;
      mlg: true,
      xl: true;
      sxl: true,
      xxl: true;
    }
  }
export const CustomBreakPoint = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      mlg: 1400,
      xl: 1536,
      sxl: 1650,
      xxl: 1800
    },
  },
});